export const APP_BAR_HEIGHT = 50
export const MENU_WIDTH = 72
export const MAX_CONTENT_WIDTH = 1920

export const BUTTON_ICON_MOBILE_PADDING = { right: 1.5, left: 1.5, top: 0.5, bottom: 0.5 }

export const COLOR_APP_BAR_DEFAULT =
  'linear-gradient(90deg, #0079FD -37.91%, #2D51FB 20.11%, #5A29FA 78.13%, #8800F8 137.91%)'

export const COLOR_APP_BAR_CHRISTMAS = 'linear-gradient(270deg, #832C2C 71.94%, #333333 95.86%)'
